import React from 'react';
import clsx from 'clsx';
import { Stack, Text, Fabric } from 'office-ui-fabric-react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { logout } from '../../utils/auth';
import Footer from '../../components/Footer';
import styles from './NotAuthorizedUser.style';
import { isMobileApp } from '../../utils';

const isMobile = isMobileApp();

const NotAuthorizedUser = () => {
  return (
    <div className={styles.root}>
      <Fabric className={clsx(styles.root, isMobile && styles.mobile)}>
        <Stack className={styles.hero}>
          <Stack align="start" className={styles.heroHeader} data-testid="header">
            <Text block>Unauthorized</Text>
          </Stack>

          <Text align="start" className={styles.heroDetails}>
            You do not currently have access to this application. Please contact an administrator or
            log in with a different account.
          </Text>
          <PrimaryButton className={styles.logoutButton} text="Log out" onClick={logout} />
        </Stack>
        <Stack>
          <Footer />
        </Stack>
      </Fabric>
    </div>
  );
};

export default NotAuthorizedUser;
